import { render, staticRenderFns } from "./LawNormView.vue?vue&type=template&id=55808556"
import script from "./LawNormView.vue?vue&type=script&lang=js"
export * from "./LawNormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports